import { ColDef, ValueFormatterParams } from 'ag-grid-community';
import {
    VACANT_POSITION_END_DATE,
    VACANT_POSITION_LABEL,
    VACANT_POSITION_NUMBER,
    VACANT_POSITION_START_DATE,
} from 'routes/HumanResourcesModule/business/definitions';
import { dateFormatter } from 'ui/AgGridReact/formatters';
import {
    DATE_FILTER,
    TEXT_FILTER,
} from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/defaultColDefs';
import { t } from 'i18next';
import { getGroupedOrgChartHrColumn } from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/orgChartHrColumnHelpers';

const customDateFormatter = (params: ValueFormatterParams): string => {
    if (params.node?.group) return '';
    return params.value
        ? dateFormatter(params)
        : t('humanResources.payState.noDate');
};

export const getColDefs = (hasNoEndDate: boolean): ColDef[] => [
    { ...getGroupedOrgChartHrColumn(), flex: 1 },
    ...[VACANT_POSITION_LABEL, VACANT_POSITION_NUMBER].map(
        (field): ColDef => ({
            ...TEXT_FILTER,
            headerName: t(`humanResources.payState.${field}`),
            field,
            enableRowGroup: true,
            flex: 1,
        }),
    ),
    ...[VACANT_POSITION_START_DATE, VACANT_POSITION_END_DATE].map(
        (field): ColDef => ({
            ...DATE_FILTER,
            headerName: t(`humanResources.payState.${field}`),
            field,
            valueGetter: (params) =>
                params.data && params.data[field]
                    ? new Date(params.data[field])
                    : undefined,
            valueFormatter: customDateFormatter,
            enableRowGroup: true,
            flex: 1,
            hide: field === VACANT_POSITION_END_DATE && hasNoEndDate,
        }),
    ),
];
